import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Outlet, useLocation } from "react-router-dom";
// import { screenChange } from "../../store/screenSlice";
import CreateEvent from "../../components/Events/CreateEvent";
import ViewEvent from "../../components/Events/ViewEvent";
import EventList from "../../components/Events/EventList";
import CreateVideoEvent from "../../components/Events/CreateVideoEvent";
import { screenConfig } from "../../config/screenConfig";
import EditEvent from "../../components/Events/EditEvent";

const EventsHomePage: React.FC = () => {
  const dispatch = useDispatch();

  const currentMenu = useSelector(
    (state: RootState) => state.screen.currentMenu
  );

  console.log("events-currentMenu:", currentMenu);
  const renderMenuPage = () => {
    switch (currentMenu) {
      case screenConfig.createEvent:
        return <CreateEvent />;
        break;
      case screenConfig.viewEvent:
        return <ViewEvent />;
        break;
      case screenConfig.editEvent:
        return <EditEvent />;
        break;
      case screenConfig.createVideoEvent:
        return <CreateVideoEvent />;
        break;
      default:
        return <EventList />;
        break;
    }
  };

  // dispatch(screenChange("Events"));
  return <div className="dashboard-wrapper">{renderMenuPage()}</div>;
};

export default EventsHomePage;
